import { useEffect, useState } from "react";
import { Telescope } from "lucide-react";

/** Branded launch splash. Shows briefly on app start (especially when launched
 *  as an installed PWA), then fades out. */
export default function Splash() {
  const [hidden, setHidden] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setHidden(true), 1500);
    const t2 = setTimeout(() => setGone(true), 2100);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (gone) return null;

  return (
    <div
      data-testid="app-splash"
      className={`fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#0A0D14] transition-opacity duration-500 ${hidden ? "opacity-0" : "opacity-100"}`}
    >
      <div className="relative">
        <div className="absolute inset-0 blur-2xl bg-amber-500/20 rounded-full scale-150" />
        <div className="relative animate-[pulse_1.4s_ease-in-out_infinite]">
          <Telescope className="w-16 h-16 text-amber-400" strokeWidth={1.4} />
        </div>
      </div>
      <h1 className="mt-6 font-serif text-3xl font-semibold tracking-tight text-slate-100">AuctionScope</h1>
      <p className="mt-1.5 text-[11px] font-mono uppercase tracking-[0.35em] text-slate-500">Art-Market Intelligence</p>
      <div className="mt-8 w-40 h-[3px] rounded-full bg-slate-800 overflow-hidden">
        <div className="h-full bg-amber-500 animate-[loadbar_1.5s_ease-in-out_forwards]" />
      </div>
      <style>{`
        @keyframes loadbar { 0% { width: 0%; } 100% { width: 100%; } }
      `}</style>
    </div>
  );
}
